const CONFIG = {
  appName: '中象在线',
  appSlogan: '专业的中国象棋在线学习平台',
  apiBaseURL:
    process.env.NODE_ENV === 'production'
      ? 'https://api.zhongxiangzaixian.com'
      : 'https://api.zhongxiangzaixian.com',

  // 下载链接
  download: {
    // APK下载地址，替换为实际的文件URL
    android: '',
    ios: '',
  },

  // 联系信息
  contact: {
    email: 'zhongxiangzaixian@163.com',
    phone: '',
    wechat: '',
  },

  // 备案信息
  icp: '鲁ICP备2025195891号-2',
};

export default CONFIG;
